<template>
    <div class="home cr-gutter">
        <h4 class="section-title p-l-10">
            Quick Links
        </h4>

        <div class="row section">
            <div class="col-md-12">
                <router-link
                    :to="{ name: 'create-resource', params: {
                        resource: 'envelopes'
                    }}"
                    class="main-caller"
                >
                    <i class="fa fa-plus mr-4" />
                    New Contract
                </router-link>
            </div>
        </div>

        <div class="row section mt-5">
            <div v-for="metric in metrics" :key="metric.name" class="col-lg-4 col-md-6">
                <dashboard-card
                    :title="metric.title"
                    :count="metric.count"
                    :icon-class="metric.iconClass"
                    :status-color="metric.statusColor"
                    @click="goTo(metric)"
                />
            </div>

            <div class="col-md-12">
                <div class="card d-flex offer-card">
                    <div class="offer-card__icon">
                        <i class="fa fa-lock-open" />
                    </div>

                    <div class="offer-card__main">
                        <h2 class="offer-card__title">Discover our <br> full offering</h2>
                        <small>Upgrade and unlock our premium options</small>
                    </div>

                    <div class="offer-card__phone">
                        <span class="phone-container">
                            <b>Call Now!</b> <br>
                            <h4 class="phone-number"> 
                                (787) <b>488-0123</b>
                            </h4>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardCard from "@c/dashboard-card"

export default {
    name: "Home",
    components: {
        DashboardCard
    },
    data() {
        return {
            metrics: [{
                name: "pending",
                title: "<span>Waiting for others</span>",
                iconClass: "fa-file-pdf",
                statusColor: "primary",
                value: "sent",
                count: 5,
                resource:"envelopes",
                statusField: "status"
            },
            {
                name: "active",
                title: "<span>Expriring Soon</span>",
                iconClass: "fa-file-pdf",
                statusColor: "primary",
                value: "expiring",
                count: 5,
                resource:"envelopes",
                statusField: "status"
            },
            {
                name: "completed",
                title: "<span>Completed </span>",
                iconClass: "fa-file-pdf",
                statusColor: "primary",
                value: "completed",
                count: 5,
                resource:"envelopes",
                statusField: "status"
            }]
        }
    },

    methods: {
        goTo(metric) {
            this.$router.push({
                name: "browse",
                params: { resource: metric.resource },
                query: {
                    [`filter.${metric.statusField}`]: `${metric.value}`
                }
            })
        }
    }
};
</script>


<style lang="scss" scoped>
.main-caller {
    background: var(--base-color);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90px;
    border-radius: 20px;
    font-size: 40px;
    
    &:hover {
        text-decoration: none;
    }
}

.offer-card {
    margin-top: 60px;
    padding: 70px;
    display: flex;
    justify-content: space-around;
    flex-direction: row;

    &__icon {
        width: 100%;
        text-align: right;
        padding-right: 50px;
        .fa {
            font-size: 100px;
            transform: rotateY(180deg) rotateZ(334deg);
            background: linear-gradient(223deg, var(--base-color) 40%, #6cf399);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            -webkit-box-decoration-break: clone;
            box-decoration-break: clone;
            text-shadow: none;
        }
    }

    &__title {
        text-transform: uppercase;
        font-size: 38px;
        color: var(--base-color);
    }

    &__main, &__phone {
        width: 100%;
        small {
            font-weight: bolder;
        }
    }

    &__phone {
        display: flex;
        align-items: center;
        text-align: left;
        padding-left: 50px;
        .phone-container {
            background: rgba(30, 143, 255, 0.301);
            color: var(--base-color);
            font-weight: bolder;
            padding: 10px 15px;
            border-radius: 10rem;
        }

    }
}
</style>
